import { render, staticRenderFns } from "./TurnAroundDoc.vue?vue&type=template&id=4f8cab1c"
import script from "./TurnAroundDoc.vue?vue&type=script&lang=ts"
export * from "./TurnAroundDoc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports